<template>
	<div>
		<Loader :show="loading" />
		<div class="row" v-if="!loading && order">
			<div class="col-12 col-md-8 offset-md-2">
				<div class="d-flex align-items-center justify-content-between">
					<h2>ORDEN DE COMPRA # {{ order.code }}</h2>
					<div class="text-right">Fecha de compra<br />{{ order.createdAt | moment('DD/MM/YYYY') }}</div>
				</div>

				<div v-if="order.status == 'CANCELLED'">
					<div class="alert alert-danger">
						<h6>Orden de compra cancelada</h6>
					</div>
				</div>
				<div v-else>
					<OrderStatusSteps :currentStatus="order.status" />
				</div>

				<div v-if="paymentSuccess" class="">
					<div class="payment d-flex mb-2">
						<div class="side-icon">
							<div class="badge badge-warning" v-if="paymentSuccess.status == 'PENDING'"><i class="icon icon-exclamation"></i></div>
							<div class="badge badge-danger" v-if="paymentSuccess.status == 'REJECTED'"><i class="icon icon-close"></i></div>
							<div class="badge badge-success" v-if="paymentSuccess.status == 'APPROVED'"><i class="icon icon-check"></i></div>
							<div class="icon-payment-provider" :class="paymentSuccess.acquirerIcon"></div>
						</div>
						<div class="data">
							<h3>{{ paymentSuccess.acquirerName }}</h3>
							<p class="m-0">Pago #{{ paymentSuccess.externalPaymentId }} acreditado el {{ paymentSuccess.paidAt | moment('DD [de] MMMM') }}</p>
						</div>
					</div>
				</div>
				<div v-if="payments.length > 0 && !paymentSuccess" class="">
					<div v-for="payment in payments" :key="payment.id">
						<div class="payment d-flex mb-2">
							<div class="side-icon">
								<div class="badge badge-warning" v-if="payment.status == 'PENDING'"><i class="icon icon-exclamation"></i></div>
								<div class="badge badge-danger" v-if="payment.status == 'REJECTED'"><i class="icon icon-close"></i></div>
								<div class="badge badge-success" v-if="payment.status == 'APPROVED'"><i class="icon icon-check"></i></div>
								<div class="icon-payment-provider" :class="payment.acquirerIcon"></div>
							</div>
							<div class="data">
								<h3>{{ payment.acquirerName }}</h3>
								<p class="m-0">Pago #{{ payment.externalPaymentId }} iniciado el {{ payment.createdAt | moment('DD [de] MMMM') }}</p>
								<p class="m-0" v-if="payment.status == 'PENDING'">{{ payment.instructions }}</p>
							</div>
						</div>
					</div>
				</div>

				<div v-if="order.paymentStatus == 'INPROCESS' && order.canPay">
					<router-link tag="a" :to="`/order/${order.code}/pay`" class="btn btn-sm btn-link">Reintentar con otro medio de pago</router-link>
				</div>

				<div v-if="order.paymentStatus == 'PENDING' && order.status == 'AWAITING_PAYMENT' && order.canPay">
					<div class="alert alert-warning d-flex justify-content-between align-items-center">
						Su compra se encuentra pendiente de pago.
						<router-link tag="a" :to="`/order/${order.code}/pay`" class="btn btn-primary">Reintentar pago</router-link>
					</div>
				</div>
			</div>

			<div class="col-12 col-md-8 offset-md-2">
				<div class="side-content">
					<div class="section-title px-2">
						<p class="text-white">.</p>
						<div class="lead-text">Detalle del pedido</div>
					</div>
					<div class="mt-2">
						<CartProductsTable :cart="order" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import gql from 'graphql-tag'
import Loader from '@/components/Loader'
import CartProductsTable from './CartProductsTable'
import OrderStatusSteps from './OrderStatusSteps'

export default {
	name: 'OrderDetail',
	components: { Loader, CartProductsTable, OrderStatusSteps },
	data() {
		return {
			loading: true,
			order: null,
		}
	},
	beforeMount() {
		setTimeout(() => {
			this.load()
		}, 1500)
	},
	computed: {
		paymentSuccess() {
			return this.order.payments.find((p) => p.status == 'APPROVED')
		},
		payments() {
			// sort payments by createdAt
			return this.order.payments.sort((a, b) => {
				return b.createdAt > a.createdAt ? 1 : -1
			})
		},
	},
	methods: {
		load() {
			return this.$apollo
				.query({
					query: gql`
						query($code: String) {
							order(code: $code) {
								id
								code
								priceSubtotal
								priceTaxes
								priceTotal
								status
								statusText
								paymentStatus
								paymentStatusText
								canPay
								createdAt
								products {
									product {
										id
										name
										image {
											id
											urlThumb
										}
										category {
											id
											title
										}
									}
									qty
									priceUnit
									priceSubtotal
								}
								client {
									id
									name
									email
									document {
										type
										number
									}
									lastname
								}
								payments {
									id
									externalPaymentId
									amount
									installments
									acquirerName
									acquirerIcon
									instructions
									last4
									status
									statusText
									statusHelp
									paidAt
									createdAt
								}
							}
						}
					`,
					variables: { code: this.$route.params.code },
					fetchPolicy: 'network-only',
				})
				.then(({ data }) => {
					this.order = data.order
					this.loading = false
				})
				.catch((err) => {
					console.log(err)
					this.$router.push('/')
				})
		},
	},
}
</script>

<style scoped>
h2 {
	font-size: 16px;
	font-weight: 600;
}

.payment {
	background-color: #f3f3f3;
	border-radius: 8px;
	padding: 16px;
	align-items: center;
}

.payment .side-icon {
	position: relative;
	width: 62px;
	height: 62px;
	border-radius: 50%;
	display: flex;
	background-color: #fff;
	align-items: center;
	justify-content: center;
}
.payment .side-icon .icon-payment-provider {
	border: solid 2px #ffffff;
	background-color: transparent;
}
.payment .side-icon .badge {
	position: absolute;
	top: -2px;
	right: -2px;
	border-radius: 50%;
	width: 18px;
	height: 18px;
	padding: 0px;
	display: flex;
	align-items: center;
	justify-content: center;
}
.payment .side-icon .badge .icon {
	filter: invert(1);
	width: 14px;
	height: 14px;
}
.payment .data {
	margin-left: 18px;
	margin-bottom: 0.5rem !important;
}
.payment .data h3 {
	font-size: 18px;
}
</style>
